import Vue from "vue";
import VueRouter from "vue-router";
import userRole from "@/helpers/userRoles.js";

const DEFAULT_TITLE = process.env.VUE_APP_NAME;
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("../views/Login.vue"),
    meta: {
      title: "Anewo Orders von datafieber.com",
    },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/activation/:token?",
    name: "activation",
    component: () => import("../views/users/Activation.vue"),
  },
  {
    path: "/pwreset",
    name: "pwreset",
    component: () => import("../views/users/PwdReset.vue"),
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: () => import("../views/Dashboard.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/meals",
    name: "meals",
    component: () => import("../views/meals/MealMgmt.vue"),
    meta: { requiresAuth: true, role: userRole.userRole.Manager },
  },
  {
    path: "/meal/edit/:id?",
    name: "meal-edit",
    component: () => import("../views/meals/MealEdit.vue"),
    meta: { requiresAuth: true, role: userRole.userRole.Manager },
  },
  {
    path: "/mealcategories",
    name: "mealcategories",
    component: () => import("../views/meals/MealCategories.vue"),
    meta: { requiresAuth: true, role: userRole.userRole.Manager },
  },
  {
    path: "/orders",
    name: "orders",
    component: () => import("../views/orders/OrderMgmt.vue"),
    meta: {
      requiresAuth: true,
      role: [userRole.userRole.Manager, userRole.userRole.CustomerAdmin],
    },
  },
  {
    path: "/customers",
    name: "customers",
    component: () => import("../views/customers/CustomerMgmt.vue"),
    meta: { requiresAuth: true, role: userRole.userRole.Manager },
  },
  {
    path: "/customer/edit/:id?",
    name: "customer-edit",
    component: () => import("../views/customers/CustomerEdit.vue"),
    meta: { requiresAuth: true, role: userRole.userRole.Manager },
  },

  {
    path: "/mitarbeiter",
    name: "mitarbeiter",
    component: () => import("../views/users/EmployeeUserMgmt.vue"),
    meta: { requiresAuth: true, role: userRole.userRole.CustomerAdmin },
  },
  {
    path: "/mitarbeiter/edit",
    name: "mitarbeiter-edit",
    props: true,
    component: () => import("../views/users/EmployeeUserForm.vue"),
    meta: { requiresAuth: true, role: userRole.userRole.CustomerAdmin },
  },
  {
    path: "/customer/settings",
    name: "customer-settings",
    component: () => import("../views/customers/CustomerSettings.vue"),
    meta: { requiresAuth: true, role: userRole.userRole.CustomerAdmin },
  },
  {
    path: "/customer/departments",
    name: "customer-departments",
    component: () => import("../views/customers/CustomerDepartments.vue"),
    meta: { requiresAuth: true, role: userRole.userRole.CustomerAdmin },
  },
  {
    path: "/user",
    name: "user",
    component: () => import("../views/users/UserMgmt.vue"),
    meta: { requiresAuth: true, role: userRole.userRole.Manager },
  },
  {
    path: "/user/edit/:id?",
    name: "user-edit",
    component: () => import("../views/users/UserForm.vue"),
    meta: { requiresAuth: true, role: userRole.userRole.Manager },
  },
  {
    path: "/notifications",
    name: "notifications",
    component: () => import("../views/notifications/NotificationMgmt.vue"),
    meta: { requiresAuth: true, role: userRole.userRole.Manager },
  },
  {
    path: "/notifications/edit/:id?",
    name: "notification-edit",
    component: () => import("../views/notifications/NotificationForm.vue"),
    meta: { requiresAuth: true, role: userRole.userRole.Manager },
  },
  {
    path: "/robots",
    name: "robots",
    component: () => import("../views/robots/RobotMgmt.vue"),
    meta: { requiresAuth: true, role: userRole.userRole.Manager },
  },
  {
    path: "/robots/edit/:id?",
    name: "robots-edit",
    component: () => import("../views/robots/RobotForm.vue"),
    meta: { requiresAuth: true, role: userRole.userRole.Manager },
  },
  {
    path: "/settings/mail",
    name: "mailsettings",
    component: () => import("../views/settings/MailSettings.vue"),
    meta: { requiresAuth: true, role: userRole.userRole.Manager },
  },
  {
    path: "/settings/mailtemplates",
    name: "mailtemplates",
    component: () => import("../views/settings/MailTemplateMgmt.vue"),
    meta: { requiresAuth: true, role: userRole.userRole.Manager },
  },
  {
    path: "/settings/mailtemplates/:id?",
    name: "mailtemplate-edit",
    component: () => import("../views/settings/MailTemplateForm.vue"),
    meta: { requiresAuth: true, role: userRole.userRole.Manager },
  },

  {
    path: "/pdftemplates/edit/:id?",
    name: "pdftemplate-edit",
    component: () => import("../views/settings/MailTemplateForm.vue"),
    meta: { requiresAuth: true, role: userRole.userRole.Manager },
  },

  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/404",
    name: "404",
    component: () => import("@/views/404.vue"),
  },
  {
    path: "*",
    redirect: { name: "404" },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

/*
router.beforeEach((to, from, next) => {
  const loggedIn = localStorage.getItem("user");

  if (to.matched.some(record => record.meta.requiresAuth) && !loggedIn) {
    //next("/login");
    this.$store.dispatch("logout").then(() => {
      next("/login");
    });
  }
  next();
});
*/
router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    let storeageUser = localStorage.getItem("user");
    if (storeageUser && JSON.parse(storeageUser) == null) {
      next({
        path: "/login",
        params: { nextUrl: to.fullPath },
      });
    } else {
      let user = JSON.parse(localStorage.getItem("user"));

      if (to.matched.some((record) => record.meta.role)) {
        if (
          user.role === userRole.userRole.SuperUser ||
          user.role === to.meta.role ||
          (Array.isArray(to.meta.role) && to.meta.role.indexOf(user.role) >= 0)
        ) {
          next();
        } else {
          next({ name: "dashboard" });
        }
      } else {
        next();
      }
    }
  } else {
    next();
  }
});

router.afterEach((to) => {
  // Use next tick to handle router history correctly
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  Vue.nextTick(() => {
    document.title = to.meta.title || DEFAULT_TITLE;
  });
});

export default router;
